import { api } from 'app/config/apiConfig';
import { InvoiceFrequencyType } from 'entities/Invoice';
import { Discount } from '../model/types';
import { UnitTypeSetting } from 'entities/RentOption';

interface Params {
  warehouseId?: string | string[];
  unitName?: string;
  unitType?: UnitTypeSetting;
  periodType?: InvoiceFrequencyType;
  contractDuration?: number;
  unitSize?: number;
  name?: string;
  priority?: number;
  isActive?: boolean;
}

export const getAllDiscountsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getAllDiscounts: build.query<Discount[], Params | void>({
      query: (args) => ({
        url: '/discounts',
        params: args ? { ...args } : undefined,
      }),
      providesTags: ['Discounts'],
    }),
  }),
});

export const { useGetAllDiscountsQuery } = getAllDiscountsApi;
